import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import Spinner from '@atlaskit/spinner';
export const LoadingSpinner = ({
  size = 'medium',
  children
}) => /*#__PURE__*/React.createElement(LoadingSpinnerContainer, null, /*#__PURE__*/React.createElement(Spinner, {
  size: size
}), /*#__PURE__*/React.createElement(LoadingSpinnerMessage, null, children));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadingSpinnerContainer = styled.div({
  textAlign: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const LoadingSpinnerMessage = styled.p({});